import Request from './../request';
import { IFlavourResourceShort } from '../../props/flavours';

// import interfaces

const FlavourService = {
  retrieve: async (): Promise<IFlavourResourceShort[]> => {
    try {
      const results = await Request.get(`/api/flavours`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  create: async (data: FormData): Promise<IFlavourResourceShort[]> => {
    try {
      const results = await Request.post(`/api/flavours`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  update: async (data: FormData, id: string): Promise<IFlavourResourceShort[]> => {
    try {
      const results = await Request.post(`/api/flavours/${id}?_method=PUT`, data, 'multipart/form-data');
      return results;
    } catch (e) {
      throw e;
    }
  },
  delete: async (id: string): Promise<IFlavourResourceShort[]> => {
    try {
      const results = await Request.delete(`/api/flavours/${id}`);
      return results;
    } catch (e) {
      throw e;
    }
  },
  reorder: async (data: FormData) => {
    try {
      const result = await Request.post(`/api/reorderFlavours`, data, 'multipart/form-data');
      return result;
    } catch (error) {
      throw error;
    }
  },
};

export default FlavourService;
